import { getPrefixRoute } from "../../../RBACPlugin";

const REACT_APP_SBMA_ASSETS_API_ENDPOINT = process.env.REACT_APP_SBMA_ASSETS_API_ENDPOINT;
const GATE_PASS_BASE_URL = REACT_APP_SBMA_ASSETS_API_ENDPOINT + "/api/v1";
const GATE_PASS_BASE_URL_1 = REACT_APP_SBMA_ASSETS_API_ENDPOINT + "/api/v1/gatepass";
const PROFILE_GATE_PASS_BASE_URL = REACT_APP_SBMA_ASSETS_API_ENDPOINT + "/api/v1/profile/gatepass";
const SERVICE_BASE_URL = REACT_APP_SBMA_ASSETS_API_ENDPOINT + "/api/v1";
const ORGANIZATION_GATE_PASS_BASE_URL = REACT_APP_SBMA_ASSETS_API_ENDPOINT + "/api/v1/org/gatepass";

export default {

    GENERATE_SINGLE_GATE_PASS:                           GATE_PASS_BASE_URL_1 + "/generate/single",
    GET_LIST_GATE_PASS:                                  GATE_PASS_BASE_URL_1 + "/list",
    VIEW_GATE_PASS:                                      GATE_PASS_BASE_URL_1 + "/qr-payload",
    UPDATE_GATE_PASS_STATUS:                             GATE_PASS_BASE_URL_1 + "/update/status",
    GENERATE_BOOKING_GATE_PASS:                          SERVICE_BASE_URL + "/vehicle-booking/generate/booking",
    GET_VEHICLE_LIST_BOOKING:                            GATE_PASS_BASE_URL_1 + "/booking",
    GENERATE_VEHICLE_GATEPASS:                           GATE_PASS_BASE_URL_1 + "/vehicle/generate",
    UPDATE_GATE_PASS:                                    GATE_PASS_BASE_URL_1 + "/update",
    FILTER_GATE_PASS:                                    GATE_PASS_BASE_URL_1 + "/filter",
    GET_GATEPASS_PASS_TYPE:                              GATE_PASS_BASE_URL + "/profile/gatepass/type/pass-type",
    GET_GATEPASS_ENTRY_TYPE:                             GATE_PASS_BASE_URL + "/profile/gatepass/type/entry-type",
    GET_GATEPASS_VEHICLE_ACCESS_LOGS:                    GATE_PASS_BASE_URL_1 + "/accesslogs",
    
    // organization gatepass
    GET_LIST_ORG_GATE_PASS:                             ORGANIZATION_GATE_PASS_BASE_URL + "/list",
    GENERATE_ORG_VEHICLE_GATE_PASS:                     ORGANIZATION_GATE_PASS_BASE_URL + "/vehicle/generate",
    FILTER_ORG_GATE_PASS:                               ORGANIZATION_GATE_PASS_BASE_URL + "/filter",        
    // GENERATE_ORG_BOOKING_GATE_PASS:                     SERVICE_BASE_URL + "/org/vehicle-booking/generate/booking",  
    GENERATE_ORG_BOOKING_GATE_PASS:                     SERVICE_BASE_URL + "/vehicle-booking/generate/booking",  
    GET_ORG_VEHICLE_LIST_BOOKING:                       ORGANIZATION_GATE_PASS_BASE_URL + "/booking",
    GENERATE_ORG_VEHICLE_GATE_PASS:                     ORGANIZATION_GATE_PASS_BASE_URL + "/vehicle/generate",
    FILTER_ORG_GATE_PASS:                               ORGANIZATION_GATE_PASS_BASE_URL + "/filter",
    GET_ORG_GATEPASS_VEHICLE_ACCESS_LOGS:               ORGANIZATION_GATE_PASS_BASE_URL + "/accesslogs",
    UPDATE_ORG_GATE_PASS_STATUS:                        ORGANIZATION_GATE_PASS_BASE_URL + "/update/status",

    // 
    
}